import React, { FC } from 'react';
import { HeaderText, TrustedShopReviews } from '@/components/ui';
import { YotpoReviewStars } from '@/components/ui/YotpoReviewStars';
import ExplorerSwitch from './ExplorerSwitch';
import ExplorerSlice from './ExplorerSlice';
import useProductContext from '@/context/ProductContext';
import { TypeProduct } from '@/core/generated-types';
import {
  shouldUseYotpoReviews,
  shouldUseTrustedShopsReviews,
} from '@/utils/helpers';
import styles from '@/components/common/Explorer/Explorer.module.scss';
import { HeaderSize } from '@/components/ui/HeaderText';
import { RichTextHeading } from '../RichTextHeading';
import { Document } from '@contentful/rich-text-types';
import { TypeTextCopy } from '@/core/generated-types';
import classNames from 'classnames';

const Explorer: FC<any> = ({
  title,
  text,
  slices,
  backgroundColor,
  anchorId: explorerAnchorId,
  titleAsH1 = false,
  showSliceAnchors = true,
  titleRichText,
  theme = 'default',
  columnsDescription,
}) => {
  const {
    enableYotpoReviewsSummary,
    enableTrustedShopsReviewsSummary,
    product,
  } = useProductContext();
  return (
    <>
      <div id={explorerAnchorId} className="relative -top-[90px]" />
      <div
        className={`flex justify-center py-8 lg:py-16 lg:px-14 bg-${backgroundColor?.fields?.color}`}
      >
        <div className="px-5">
          {title &&
            (titleAsH1 ? (
              <HeaderText size={HeaderSize.H1} text={title} align="center" />
            ) : (
              <h2 className="text-center text-d-h2 font-bold lg:text-d-h1">
                {title}
              </h2>
            ))}
          {titleRichText && (
            <div
              className={classNames('text-center', styles.title)}
              data-testid="rich-text-heading"
            >
              <RichTextHeading content={titleRichText as Document} />
            </div>
          )}
          {shouldUseYotpoReviews() && enableYotpoReviewsSummary && (
            <div
              className={`plp-reviews-summary mt-2 flex justify-center ${styles.root}`}
            >
              <YotpoReviewStars product={product as TypeProduct} />
            </div>
          )}
          {shouldUseTrustedShopsReviews() &&
            enableTrustedShopsReviewsSummary && (
              <div className="text-d-base">
                <TrustedShopReviews
                  widgetType="ratings-long"
                  shopifyProduct={null}
                />
              </div>
            )}
          {columnsDescription && (
            <div className="grid grid-cols-2 gap-y-1 gap-x-4 lg:gap-y-3 lg:gap-x-16 place-items-center text-lg md:text-2xl">
              {columnsDescription.map((item: TypeTextCopy, index: number) => {
                return (
                  <p
                    key={index}
                    className={`${index % 2 === 0 ? 'justify-self-end' : 'justify-self-start'}`}
                  >
                    {item.fields.text}
                  </p>
                );
              })}
            </div>
          )}
          {text && <p className="text-center text-d-lg">{text}</p>}
          {showSliceAnchors && <ExplorerSwitch slices={slices} theme={theme} />}
          {slices &&
            slices?.map(({ fields: slice }: any) => (
              <ExplorerSlice key={slice.anchorId} {...slice} />
            ))}
        </div>
      </div>
    </>
  );
};

export default React.memo(Explorer);
